// platform_tabs — ported from builder/components/sections/Platform/Platform.mdx (## JS).
// Single-select tabs: clicking a tab toggles aria-selected on the tabs and
// [hidden] on the panels IN PLACE (no DOM rebuild — the tabs row's scroll
// position is preserved). ArrowLeft/ArrowRight cycle the active tab per the
// ARIA tablist convention; .focus() scrolls the focused tab into view.
import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['tab', 'panel']

  activate(event) {
    this.#select(event.currentTarget.dataset.stage)
  }

  nav(event) {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return
    event.preventDefault()
    const tabs = this.tabTargets
    const i = tabs.indexOf(event.currentTarget)
    const dir = event.key === 'ArrowLeft' ? -1 : 1
    const next = tabs[(i + dir + tabs.length) % tabs.length]
    this.#select(next.dataset.stage)
    next.focus()
  }

  #select(id) {
    this.tabTargets.forEach(tab => {
      tab.setAttribute('aria-selected', String(tab.dataset.stage === id))
    })
    this.panelTargets.forEach(panel => {
      panel.hidden = panel.dataset.stagePanel !== id
    })
  }
}
